module.exports = __webpack_public_path__ + "img/css_2.6971ddc7.svg";